module.exports = __webpack_public_path__ + "img/dilnoor.6b39c608.jpg";